// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"8":"8614b746","26":"3b69412d","272":"155ad1c0","402":"d353aa9a","407":"8da2f64f","432":"2db590ae","453":"3586613e","490":"5f3e76be","974":"169df442"}[chunkId] + ".js";
};